<template>
  <div style="height: 100%; overflow-y: auto;">
    <div v-if="isLoaded && table.items">
      <v-simple-table>
        <template #default>
          <tbody>
            <tr
              v-for="(item, name) in table.headersExtendTranslate"
              :key="name"
            >
              <th>{{ item.label }}</th>
              <td>{{ table.items[name] }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <div v-else-if="isLoaded && !table.items">
      <h4>Нет информации...</h4>
    </div>

    <v-progress-linear
      v-else
      indeterminate
      color="success"
    ></v-progress-linear>
  </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'OutgoingCalls',
  props: {
    view: String,
    widget: Object,
  },
  data() {
    return {
      isLoaded: false,
      table: {
        items: [],
        headersExtendTranslate: {
          avg_duration: {
            label: "Средняя длительность вызова ",
            additional: 'сек.'
          },
          min_duration: {
            label: "Мин. длительность вызова ",
            additional: 'сек.'
          },
          max_duration: {
            label: "Макс. длительность вызова ",
            additional: 'сек.'
          },
          sum_duration: {
            label: "Общая длительность вызовов ",
            additional: ''
          },
          talk_duration: {
            label: "Длительность разговора",
            additional: ''
          },
          min_wait_duration: {
            label: "Мин. время ожидания ",
            additional: 'сек.'
          },
          avg_wait_duration: {
            label: "Среднее время ожидания ",
            additional: 'сек.'
          },
          max_wait_duration: {
            label: "Макс. время ожидания ",
            additional: 'сек.'
          },
          avg_wait_duration_accepted_calls: {
            label: "Среднее время ожидания (принятые) ",
            additional: 'сек.'
          },
          avg_wait_duration_missed_calls: {
            label: "Среднее время ожидания (пропущенные) ",
            additional: 'сек.'
          },
        },
      },
    }
  },

  computed: {
    ...mapGetters({
    }),
  },

  watch: {},

  methods: {
    ...mapActions({
      loadExtendedOutgoingStatistic: 'dashboard/loadExtendedOutgoingStatistic',
    }),

    async loadData() {
      this.isLoaded = false;
      this.table.items = await this.loadExtendedOutgoingStatistic(this.widget.params);
      this.isLoaded = true;
    },
  },
  
  mounted() {
    this.loadData();
  },
}
</script>


<style scoped lang="scss">

</style>